
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/material-ui-v1-is-out",
      function () {
        return require("private-next-pages/blog/material-ui-v1-is-out.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/material-ui-v1-is-out"])
      });
    }
  